import { styled, css } from 'styled-components';

import Chevron from './chevron';
import { ActionWrapperProps } from './types';

export const IconWrapper = styled.div`
  svg {
    display: block;
    width: 16px;
    aspect-ratio: 1;
    object-position: center;

    @media screen and (min-width: 1024px) {
      width: 24px;
    }
  }
`;

export const TextWrapper = styled.div``;

const mobileRoundVariantStyles = css`
  @media screen and (max-width: 1023px) {
    grid-template-columns: 1fr;
    gap: 4px;
    justify-items: center;
    padding: 8px;
    width: auto;
    height: auto;
    font-size: var(--font-size-label);
    font-family: var(--font-lausanne);
    text-align: center;

    ${IconWrapper} {
      display: grid;
      place-items: center;
      width: 40px;
      aspect-ratio: 1;
      border-radius: 50%;
      background-color: #fff;

      svg {
        width: 24px;
      }

      @media screen and (min-width: 375px) {
        width: 50px;
      }
    }

    ${Chevron} {
      display: none;
    }

    &:disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &:hover {
      background-color: unset;
    }
  }
`;

type ActionWrapperStyleProps = {
  $isMuted: ActionWrapperProps['isMuted'];
  $mobileVariant: ActionWrapperProps['mobileVariant'];
};

const actionWrapperStyles = css<ActionWrapperStyleProps>`
  width: 100%;
  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-columns: 16px 1fr auto;
  gap: 20px;
  height: 52px;
  padding: 0 16px;
  font-family: var(--font-lausanne);
  font-size: var(--font-size-body);
  cursor: pointer;
  color: #212322;
  background-color: unset;

  ${Chevron} {
    display: block;
    justify-self: end;
    aspect-ratio: 12 / 13;
    height: 12px;
    width: auto;

    path {
      vector-effect: non-scaling-stroke;
    }
  }

  &:disabled {
    opacity: 0.2;
    pointer-events: none;
  }

  &:hover {
    background-color: #f4f4f4;
  }

  ${({ $isMuted }) =>
    $isMuted &&
    css`
      ${Chevron} {
        opacity: 0.5;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    `}

  @media screen and (min-width: 1024px) {
    grid-template-columns: 24px 1fr auto;
    height: 60px;
    padding: 0 24px;

    ${Chevron} {
      height: 16px;
    }
  }

  ${({ $mobileVariant }) => $mobileVariant === 'round' && mobileRoundVariantStyles}
`;

export const ActionItemLinkWrapper = styled.a<ActionWrapperStyleProps>`
  ${actionWrapperStyles}
`;

export const ActionItemButtonWrapper = styled.button<ActionWrapperStyleProps>`
  border: none;
  font: inherit;
  text-align: left;

  ${actionWrapperStyles}
`;
